import Vue from 'vue'
import Router from 'vue-router'
import Forgetpwd from './views/password/ResetPwd.vue'
import Register from './views/register/Register.vue'
import SecurityCenter from './views/security/SecurityCenter.vue'
import BindAccount from './views/binding/BindAccount'
import Success from './views/register/RegisterSuccess.vue'
import BindResult from './views/binding/BindResult.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/register'
    },
    {
      path: '/registerEnterprise',
      redirect: '/register'
    },
    {
      path: '/forgetpwd',
      name: 'forgetpwd',
      component: Forgetpwd
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/security-center',
      name: 'security-center',
      component: SecurityCenter
    },
    {
      path: '/bind-account/:type?',
      name: 'bind-account',
      component: BindAccount,
      props: true
    },
    {
      path: '/registerSuccess',
      name: 'registerSuccess',
      component: Success
    },
    {
      path: '/bindResult/:type?',
      name: 'bindResult',
      component: BindResult,
      props: true
    }
  ]
})
